<script lang="ts">
	import type { StoreUserMinDTO } from "@hitit/api";
	import moment from "moment";
	import { t } from "@hitit/hub/src/stores";
	export let user: StoreUserMinDTO;
	export let borderBottom = false;

	$: formatDate = moment(new Date(user.createdDate + "Z").toISOString()).format(
		"yyyy.MM.DD"
	);

</script>

<div class="row" class:borderBottom on:click>
	<div class="phone col">{user.userIdentity}</div>
	<div class="create col">
		{formatDate}
		<span class="for-mobile">{$t('global.register')}</span>
	</div>
	<div class="current col">
		<span class="for-mobile">{$t('global.Now')}</span>
		{user.totalActiveReward}P
	</div>
	<div class="accumulate col">{user.totalReward}P</div>
	<div class="used col">{user.totalUsedReward}P</div>
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.row {
		width: 100%;
		transition: 0.2s background-color;

		&.borderBottom {
			border-bottom: 1px solid #e6e7ec;
		}

		display: flex;
		flex-direction: column;
		padding: 10px 0px;
		box-sizing: border-box;
		gap: 10px;
		.phone {
			font-size: 1.25rem;
			font-weight: 500;
			color: #46474b;
			order: 1;
		}

		.current {
			font-weight: 500;
			color: #46474b;
			order: 2;
		}

		.create {
			font-size: 0.875rem;
			color: #6d6f76;
			order: 3;
		}

		.accumulate,
		.used {
			display: none;
		}
	}

	@include DesktopSize {
		.for-mobile {
			display: none;
		}

		.row {
			&:hover {
				cursor: pointer;
				background-color: #f0f0f4;
			}
			display: flex;
			flex-direction: row;
			padding: 20px 0px;
			.col {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 20%;
				max-width: 20%;
				color: #6d6f76;
				font-size: 1.25rem;
			}

			.phone {
				font-size: 1.25rem;
				color: #46474b;
				order: 1;
			}

			.current {
				font-weight: 500;
				color: #46474b;
				order: 3;
			}
			.accumulate {
				color: #46474b;
				order: 4;
			}
			.used {
				color: #46474b;
				order: 5;
			}

			.create {
				font-size: 1.25rem;
				color: #46474b;
				order: 2;
			}
			.col {
				display: block;
				text-align: center;
				text-overflow: ellipsis;
				white-space: nowrap;
				overflow: hidden;
			}
			.phone,
			.current {
				font-weight: 550;
			}
		}

		/* .create {
						background-color: red;
					}
					.phone {
						background-color: blue;
					}
					.current {
						background-color: orange;
					}
					.accumulate {
						background-color: bisque;
					}
					.used {
						background-color: aqua;
					} */
	}

</style>
